import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInAnimation } from 'app/core/route-animation/route.animation';
import { SpinnerService } from 'app/services/spinner.service';
import { RegisterService } from 'app/services/user/register.service';

@Component({
  selector: 'ms-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css'],
  encapsulation: ViewEncapsulation.None,
  host: {
    "[@fadeInAnimation]": 'true'
  },
  animations: [fadeInAnimation]
})
export class SummaryComponent implements OnInit {

  registerId: any;
  personalData: any;
  companyData: any;

  constructor(
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private registerService: RegisterService,
    private spinnerService: SpinnerService) { }

  ngOnInit(): void {
    this.spinnerService.start();
    this.registerId = this.activatedRouter.snapshot.paramMap.get("registerId");

    this.registerService.getRegisteredUser().subscribe(data => {
      /* console.log(data); */
      this.personalData = data.personalDetail;
      this.companyData = data.companyDetail;
      this.spinnerService.stop();
    });
  }

  editPersonalDetail() {
    this.spinnerService.start();
    this.router.navigate(['/registrazione/' + this.registerId + '/personalDetail']);
  }

  editCompanyDetail() {
    this.spinnerService.start();
    this.router.navigate(['/registrazione/' + this.registerId + '/companyDetail']);
  }

  goToContractInto() {
    this.spinnerService.start();
    this.router.navigate(['/registrazione/' + this.registerId + '/contract/intro']);
  }

  goToCompanyDetail() {
    this.spinnerService.start();
    this.router.navigate(['/registrazione/' + this.registerId + '/companyDetail']);
  }
}
